module.exports = __webpack_public_path__ + "static/media/section1.c279d7cd.png";